import { Checkbox, Typography, WithInfoIcon } from 'seagull';
import styles from "./SignatoryCheckbox.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
const SignatoryCheckbox = _ref => {
  let {
    info,
    value,
    onChange,
    disabled = false,
    disableInfoIcon,
    checkboxTestid = 'required-sign',
    infoTestid = 'required-sign-info'
  } = _ref;
  return /*#__PURE__*/_jsx(WithInfoIcon, {
    showInfo: !disableInfoIcon,
    infoTestId: infoTestid,
    info: info,
    className: styles.signatoryCheckbox,
    children: /*#__PURE__*/_jsx(Checkbox, {
      "data-testid": checkboxTestid,
      onChange: onChange,
      checked: value,
      disabled: disabled,
      children: /*#__PURE__*/_jsx(Typography, {
        noWrap: true,
        children: "Required to sign"
      })
    })
  });
};
export default SignatoryCheckbox;